import { Tooltip } from '@foam/buoy/src/components/Tooltip/Tooltip';
import { cn } from '@foam/buoy/src/lib/utils';

import { BrandItem } from './BrandExperience';

export interface BrandItemComponentProps {
  item: BrandItem;
  idx: number;
  className?: string;
}

export const BrandItemComponent = ({
  item,
  idx,
  className = '',
}: BrandItemComponentProps) => (
  <div
    key={`${item.alt}-${idx}`}
    className={cn(
      'flex h-40 items-center justify-center rounded-8 px-2',
      className,
    )}
  >
    <Tooltip content={item.alt} data-testid="content-tooltip">
      <img
        src={item.src}
        alt={item.alt}
        className="size-auto max-h-20 max-w-32 object-contain"
        loading="lazy"
        draggable={false}
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.style.display = 'none';
          const parent = target.parentElement;
          if (parent) {
            parent.innerHTML = `
            <div class="w-full h-full flex items-center justify-center text-neutral-600 font-medium text-sm text-center px-2">
              ${item.alt}
            </div>
          `;
          }
        }}
      />
    </Tooltip>
  </div>
);
